import { functions } from '../../config/firebase'
import { getCallableErrorMessage } from '../ProductsSyncMenu/syncDateUtils'

const getTurboSmsBalance = async () => {
  try {
    const callable = functions.httpsCallable('getTurboSmsBalance')
    const result = await callable({})
    return { ok: true, data: result.data }
  } catch (error) {
    console.error('[getTurboSmsBalance] failed:', error)
    return {
      ok: false,
      message: getCallableErrorMessage(error),
      code: error?.code || null,
    }
  }
}

export default getTurboSmsBalance
